import { render } from "./DownGuardados.vue?vue&type=template&id=6392ddcc&scoped=true"
import script from "./DownGuardados.vue?vue&type=script&lang=js"
export * from "./DownGuardados.vue?vue&type=script&lang=js"

import "./DownGuardados.vue?vue&type=style&index=0&id=6392ddcc&scoped=true&lang=css"
import "./DownGuardados.vue?vue&type=style&index=1&id=6392ddcc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6392ddcc"

export default script